import { optionalToJS } from './utils';

export const getProfile = (state) => optionalToJS(state.entities.get('userProfile').first());
export const getFeatureStatus = (state, feature) => {
  const profile = state.entities.get('userProfile').first();

  if (!profile) return null;
  else return profile.getIn(['features', feature]);
};

export const getClient = (state) => optionalToJS(state.entities.get('myClient'))
export const getUsers = (state) => optionalToJS(state.entities.get('subUsers'))
export const getProfileUser = (state) => optionalToJS(state.entities.get('profileUser'))
export const isFetching = (state) => state.subusers.isFetching
export const isFetchingProfileUser = (state) => state.profileuser.isFetching



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/profile.js